import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import Alert from './Alert.jsx';

const FormArticleAlertMsg = () => {
  const { errors, touched } = useFormikContext();
  const { questions, extraReading, ...otherErr } = errors;

  const [show, setShow] = useState(true);
  useEffect(() => setShow(true), [errors, touched]);

  // add question number to each question's error msg
  const addIndexToMsg = (msg, questionNo) => {
    const position = msg.search('question');
    return [msg.slice(0, position + 8),
      questionNo,
      msg.slice(position + 8)]
      .join('');
  };

  let errMsgArr = [];

  // handle questions error
  if (questions && touched.questions) {
    for (let i = 0; i < questions.length; i += 1) {
      if (typeof questions[i] !== 'undefined' && touched.questions[i]) {
        const quesKeys = Object.keys(questions[i]);
        if (quesKeys.includes('answer') && 'answer' in touched.questions[i]) {
          errMsgArr.push(addIndexToMsg(questions[i].answer, i + 1));
        } else if (quesKeys.includes('answers') && 'answers' in touched.questions[i]) {
          errMsgArr.push(addIndexToMsg(questions[i].answers, i + 1));
        }
        if (quesKeys.includes('question') && 'question' in touched.questions[i]) {
          errMsgArr.push(addIndexToMsg(questions[i].question, i + 1));
        }
      }
    }
  }
  // handle url error
  if (extraReading && touched.extraReading) {
    errMsgArr.push(extraReading.url);
  }

  // handle remaining error
  errMsgArr = errMsgArr.concat(Object.values(otherErr));

  return (
    <>
      {errMsgArr.length !== 0 && show
        ? (
        <Alert onClose={() => setShow(false)}>
          {errMsgArr.map((err, i) => (
            <li key={i}>
              {err}
            </li>
          ))}
        </Alert>
        )
        : null
      }
    </>
  );
};

export default FormArticleAlertMsg;
